require("js/bootstrap");

import { createApp } from "vue";
import App from "./App.vue";
import { createWebHistory, createRouter } from "vue-router";
import { createPinia } from "pinia";
import routes from "js/router/index.js";
import { createAuthGuard } from "js/router/guard.js";
import { setUnauthorizedHandler } from "js/lib/server.js";
import { useUserStore } from "js/stores/userStore.js";
import { usePageErrorStore } from "js/stores/pageErrorStore.js";
import tripper from "js/tripper/plugin.js";
import Bttn from "js/components/common/Bttn";
import LinkBttn from "js/components/common/LinkBttn";
import Dropdown from "js/components/common/Dropdown.vue";
import SubMenu from "js/components/common/SubMenu.vue";
import EnhancedDropdown from "js/components/common/EnhancedDropdown.vue";
import MultiselectableDropdown from "js/components/common/MultiselectableDropdown.vue";
import Share from "js/components/common/Share.vue";

const app = createApp(App);

/**
 * Vue router
 */

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            let hashLocation = {
                el: to.hash,
                top: 20,
                behavior: "smooth",
            };
            if (to.name === from.name) {
                return hashLocation;
            }
            // Add delay so the page has time to load
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(hashLocation);
                }, 500);
            });
        } else if (to.path === from.path) {
            return false;
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return {
                el: "#app",
                behavior: "auto",
            };
        }
    },
});

app.use(router);
app.use(createPinia());
app.use(tripper);

router.beforeEach(createAuthGuard());
setUnauthorizedHandler(() => {
    if (!useUserStore().isLoggedIn) {
        return false;
    }
    window.location.href =
        "/login?redir=" +
        encodeURIComponent(window.location.pathname + window.location.search);
    return true;
});
router.afterEach(() => {
    usePageErrorStore().clear();
});

// this will no longer be needed for future releases, but for now set this so composition API type refs don't need .value
app.config.unwrapInjectedRef = true;

app.directive("focus-out", {
    mounted: (el, binding) => {
        el.clickOutsideEvent = (event) => {
            if (!(el == event.target || el.contains(event.target))) {
                binding.value();
            }
        };

        // Set a bit of timeout so that a click just before the element is rendered doesn't automatically close the element
        setTimeout(() => {
            document.addEventListener("click", el.clickOutsideEvent);
        }, 10);
    },
    unmounted: (el) => {
        document.removeEventListener("click", el.clickOutsideEvent);
    },
});

app.component("Bttn", Bttn);
app.component("LinkBttn", LinkBttn);
app.component("Dropdown", Dropdown);
app.component("EnhancedDropdown", EnhancedDropdown);
app.component("MultiselectableDropdown", MultiselectableDropdown);
app.component("SubMenu", SubMenu);
app.component("Share", Share);

app.mount("#app");
